export enum ApprovalSecurityStatus {
  Ok = 'OK',
  BadRequest = 'BadRequest',
  Forbidden = 'Forbidden',
}
